export const SEARCH_ROOM_MAX_PAYING_GUESTS = 6;

function toCount(value) {
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? n : 0;
}

export function cloneSearchRooms(rooms) {
  if (!Array.isArray(rooms) || rooms.length === 0) {
    return [{ adults: 2, kids: 0, infants: 0, kidsAges: [] }];
  }
  return rooms.map((room) => ({
    ...room,
    adults: toCount(room?.adults),
    kids: toCount(room?.kids),
    infants: toCount(room?.infants),
    kidsAges: Array.isArray(room?.kidsAges) ? [...room.kidsAges] : [],
  }));
}

export function cloneSearchRoomInfo(roomInfo) {
  return { rooms: cloneSearchRooms(roomInfo?.rooms) };
}

export function searchRoomInfoFingerprint(roomInfo) {
  return cloneSearchRooms(roomInfo?.rooms)
    .map((room) => `${room.adults}:${room.kids}:${room.infants}:${room.kidsAges.join("-")}`)
    .join("|");
}

export function searchRoomInfoEquals(a, b) {
  return searchRoomInfoFingerprint(a) === searchRoomInfoFingerprint(b);
}

export function adjustSearchRoomCount(rooms, index, field, delta) {
  const list = cloneSearchRooms(rooms);
  const room = list[index];
  if (!room) return { rooms: list, error: null };

  if (field === "adults") {
    const next = room.adults + delta;
    if (next < 1) return { rooms: list, error: null };
    if (delta > 0 && next + room.kids > SEARCH_ROOM_MAX_PAYING_GUESTS) {
      return { rooms: list, error: "maxguests" };
    }
    list[index] = { ...room, adults: next };
    return { rooms: list, error: null };
  }

  if (field === "kids") {
    const next = room.kids + delta;
    if (next < 0) return { rooms: list, error: null };
    if (delta > 0 && room.adults + next > SEARCH_ROOM_MAX_PAYING_GUESTS) {
      return { rooms: list, error: "maxguests" };
    }
    const kidsAges = [...room.kidsAges];
    if (delta > 0) kidsAges.push(2);
    else if (kidsAges.length > 0) kidsAges.pop();
    list[index] = { ...room, kids: next, kidsAges };
    return { rooms: list, error: null };
  }

  if (field === "infants") {
    list[index] = { ...room, infants: Math.max(0, room.infants + delta) };
    return { rooms: list, error: null };
  }

  return { rooms: list, error: null };
}

export function addSearchRoom(rooms, newRoom) {
  const extra = cloneSearchRooms([
    newRoom || { adults: 2, kids: 0, infants: 0, kidsAges: [] },
  ])[0];
  return [...cloneSearchRooms(rooms), extra];
}

export function removeSearchRoom(rooms, index) {
  const list = cloneSearchRooms(rooms);
  if (index < 1 || list.length <= 1) return list;
  list.splice(index, 1);
  return list;
}

export function setSearchKidAge(rooms, roomIndex, kidIndex, age) {
  const list = cloneSearchRooms(rooms);
  const room = list[roomIndex];
  if (!room) return list;
  const kidsAges = [...room.kidsAges];
  if (kidIndex < 0 || kidIndex >= kidsAges.length) return list;
  const parsed = parseInt(age, 10);
  kidsAges[kidIndex] = Number.isFinite(parsed) ? parsed : kidsAges[kidIndex];
  list[roomIndex] = { ...room, kidsAges };
  return list;
}
